import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionProps {
  question: string;
  answer: string;
}
export function Accordion({
  question,
  answer
}: AccordionProps) {
  return <details className="group bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden [&_summary::-webkit-details-marker]:hidden" data-id="element-95">
      <summary className="flex items-center justify-between p-6 cursor-pointer text-xl font-semibold text-gray-900 focus:outline-none focus:bg-gray-50 hover:bg-gray-50 transition-colors" data-id="element-96">
        <span data-id="element-97">{question}</span>
        <span className="transition duration-300 group-open:-rotate-180 text-emerald-600 ml-4 flex-shrink-0" data-id="element-98">
          <ChevronDownIcon className="w-6 h-6" aria-hidden="true" data-id="element-99" />
        </span>
      </summary>
      <div className="p-6 pt-0 text-lg text-gray-700 leading-relaxed border-t border-gray-100 mt-2" data-id="element-100">
        <p className="pt-4" data-id="element-101">{answer}</p>
      </div>
    </details>;
}